import React from 'react';

import { BottomLink, Container, Content, IconContainer, Text, Title } from './FinishModal.styled';
import CalendarIcon from 'components/SVG/Calendar';
import LeftBracket from 'components/SVG/LeftBracket';
import RightBracket from 'components/SVG/RightBracket';
import { Modal } from 'components/v2/Modal/Modal';

type Props = {
  visible: boolean;
  dismiss: () => void;
};

export const FinishModal: React.FC<Props> = ({ visible, dismiss }) => (
  <Modal onCancel={dismiss} open={visible} title="Period Tracking">
    <Container>
      <Content>
        <IconContainer>
          <LeftBracket />
          <CalendarIcon />
          <RightBracket />
        </IconContainer>
        <Title>Great!</Title>
        <Text>
          Your care team has been notified. If you are starting a treatment cycle this month you
          will hear from your care team about the next steps soon!
        </Text>
        <BottomLink onClick={dismiss}>Okay</BottomLink>
      </Content>
    </Container>
  </Modal>
);
